/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalitybigfiveemotionalstabilityleft5Inputs */



/**
* | output |
* | --- |
* | "Worrier" |
*
* @param {Personalitybigfiveemotionalstabilityleft5Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalitybigfiveemotionalstabilityleft5 = /** @type {((inputs?: Personalitybigfiveemotionalstabilityleft5Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalitybigfiveemotionalstabilityleft5Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Worrier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preocupado")
	return /** @type {LocalizedString} */ ("Тревожник")
});
export { personalitybigfiveemotionalstabilityleft5 as "personalityBigFiveEmotionalStabilityLeft" }